import { URL_LOCALCONTENT_ROUTE, URL_SUFFIX_LOCALCONTENT_PRODUCT_DETAILS } from '../../constants';
import { URL_LIBX_ROUTE, URL_SUFFIX_LIBX_PRODUCT_DETAILS } from '../../../libx/constants';

function createLCYourTitlesProductDetailLink(id: string, isCollectionNavigationV2Enabled: boolean) {
    return isCollectionNavigationV2Enabled
        ? `/collectionmgmt/${URL_LOCALCONTENT_ROUTE}/${URL_SUFFIX_LOCALCONTENT_PRODUCT_DETAILS}/${id}`
        : `/${URL_LOCALCONTENT_ROUTE}/${URL_SUFFIX_LOCALCONTENT_PRODUCT_DETAILS}/${id}`;
}

function createLibxchangeProductDetailLink(id: string) {
    return `/${URL_LIBX_ROUTE}/${URL_SUFFIX_LIBX_PRODUCT_DETAILS}/${id}`;
}

function createLCCollectionProductDetailLink(
    isFromLibx: boolean = false,
    id: string,
    isCollectionNavigationV2Enabled: boolean
) {
    if (isFromLibx) {
        return createLibxchangeProductDetailLink(id);
    } else {
        return createLCYourTitlesProductDetailLink(id, isCollectionNavigationV2Enabled);
    }
}

export { createLCYourTitlesProductDetailLink, createLibxchangeProductDetailLink, createLCCollectionProductDetailLink };
